import i18next from 'i18next'
import * as React from 'react'
import { any, fromJSX, StandardLocalWidget } from 'widgets-for-react'
import { FormControls } from '../../utils/forms'
import { DataLayer } from '../../utils/datalayer'
import { ComponentDidMount } from '../../utils/lifecycleMethods'
import { camelize } from '../../utils/utils'
import { CompanyTypeSelectorState, emptyCompanyType, CompanyType, companyTypeSelectorStateUpdaters } from './companyTypeSelectorState'
import { singleValidatorResultBuilders } from '../../validator/validator'


const translateCompanyType = (title: string) => i18next.t(`companyTypes:${camelize(title)}`)

export const companyTypeSelectorWidget =
  (
    availableCompanyTypes: Array<CompanyType>,
    showValidation: boolean = true,
    readonly: boolean = false,
    suppressHotjar: boolean,
    onSelectValue: (value: string) => void
  ): StandardLocalWidget<CompanyTypeSelectorState> =>
  (currentState: CompanyTypeSelectorState) => {
    const selected =
      (availableCompanyTypes.find((type) => type.Title == currentState.input.Title)) ||
      emptyCompanyType

    return any([
      currentState.validator
        .widget()
        .map(companyTypeSelectorStateUpdaters.validation),
      fromJSX((setState) => {
        if (currentState.input.Title === undefined &&
          selected.Title !== undefined
        ) {
          setState((s) => ({ ...s, input: selected }))
        }
        return (
          <>
            <ComponentDidMount
              onMount={() => {
                if (selected.Title !== undefined) {
                    onSelectValue(selected.Title)
                }
              }}
            />
            
            <FormControls.FormSelectInGroup
              controlId="companyTypeSelector"
              label={i18next.t('subscription:CompanyType')}
              readOnly={readonly}
              required={true}
              value={selected.Title || ''}
              onChange={(newValue) => {
                  const newCompanyType =
                  availableCompanyTypes.find(
                      (companyType) => companyType.Title == newValue
                  ) || emptyCompanyType
                  setState(companyTypeSelectorStateUpdaters.input(() => newCompanyType))
                  if (newCompanyType.Title !== undefined) {
                    onSelectValue(newCompanyType.Title);
                  }
              }}
              validation={
                  showValidation
                  ? currentState.validatorResult.path('Title')
                  : undefined
              }
              suppressHotjar={suppressHotjar}
              >
              {[
                  <option value="" disabled={true}>
                  {i18next.t('auth:selectPlaceholder', {
                      entity: i18next.t('subscription:CompanyType').toLowerCase(),
                  })}
                  </option>,
                  ...availableCompanyTypes.map((companyType) =>
                  companyType.Title !== undefined ? (
                      <option value={companyType.Title}>
                      {translateCompanyType(companyType.Title)}
                      </option>
                  ) : (
                      <></>
                  )
                  ),
              ]}
            </FormControls.FormSelectInGroup>
          </>
        )
      }),
    ])
  }
